import React from 'react';
import { parseToBoolean, openAnalystPage } from '../../utils/general/general';
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import { enterKeyPressed } from '../../utils/general/enterKey';
import { switchPage } from '../../utils/api/pageControl';

interface IAuthorNameProps {
    serial: number;
    authorWithAC?: string;
    analystId: string;
    clickableAnalyst: boolean;
    isACAnalyst: boolean;
    displayName: string;
    analystNumber: string;
}
class AuthorName extends React.PureComponent<IAuthorNameProps, any> {
    private ANALYST_NAME = React.createRef<HTMLDivElement>();
    constructor(props: IAuthorNameProps) {
        super(props);
    }

    public componentDidMount() {
        this.ANALYST_NAME.current && checkDomEntitlement(this.ANALYST_NAME.current);
    }

    public openAuthorsPage = (filterValue: string, selectedAuthorTabIndex?: number) => {
        if (window.HTML_RENDITION.initialData.isDeaden('ANALYST_NAME')) {
            return;
        }
        RSCH_HTML_TRACKING_CONFIG.trackAuthorNameClick(this.props.analystId, this.props.authorWithAC || '');

        if (!parseToBoolean(window.HTML_RENDITION.initialData.analyst_page_switch_entrance)) {
            window.HTML_RENDITION.scope.bioIframePageUrl = null;
            window.HTML_RENDITION.scope.analystId = this.props.analystId;
            window.HTML_RENDITION.scope.researchPageUrl = null;
            window.HTML_RENDITION.scope.selectedAuthorTabIndex = selectedAuthorTabIndex ? selectedAuthorTabIndex : 0;
            switchPage('authorsPage', 'authorName', filterValue);
            return;
        }

        openAnalystPage(this.props.analystNumber, "_blank");
    };

    public render() {
        return (
            <div ref={this.ANALYST_NAME} data-entitlement="ANALYST_NAME" id={'authorName' + this.props.serial} className="authorName text-overflow" title={this.props.authorWithAC} data-name={this.props.analystId}>
                {this.props.clickableAnalyst
                    ? (
                        <a
                            tabIndex={0} aria-label={this.props.displayName}
                            className="x-rsch-hyperlink" role="link"
                            onKeyPress={(e) => enterKeyPressed(e, this.openAuthorsPage.bind(this, this.props.displayName, this.props.serial))}
                            onClick={() => this.openAuthorsPage(this.props.displayName, this.props.serial)}
                        >{this.props.displayName}
                        </a>
                    )
                    : (
                        <span className="authorUnclickName deaden">{this.props.displayName}</span>
                    )
                }
                {this.props.isACAnalyst && <sup>AC</sup>}
            </div>
        );
    }
}
export default AuthorName;
